<template>
	<Col class="height-100 width-100 content-wrapper flex-align-center">
		<Col class="inner-content-container width-100">
			<Col class="note-container mb-7">
				NOTE: dropdowns are not sharable and do not have visibility.<br />They appear when at least one feature that is shared with the user
				is visible.<br />To let users see the dropdown, share the features included in it.
			</Col>
			<AppLoader v-if="isLoading" />
			<template v-else>
				<Row class="design-button-container flex-justify-space-between flex-align-center mb-4">
					<h3 class="design">Design</h3>
					<Row class="flex-align-center">
						<ButtonsDropdownIcon class="py-1 px-5 mr-3" :buttonDropdown="buttonDropdown" />
						<AnemicButton
							:disabled="!hasEditPermissions"
							@click="openEditButtonDropdownDesignDialog"
							class="px-3 edit-button-design-button"
						>
							Edit
						</AnemicButton>
					</Row>
				</Row>
				<EditButtonsDropdownWorkflows :buttonDropdown="buttonDropdown" :hasEditPermissions="hasEditPermissions" />
			</template>
		</Col>
	</Col>
</template>

<script>
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import { getButtonDropdown } from '@/store/modules/buttonDropdowns/actions';
import ButtonsDropdownIcon from '@/components/ButtonsDropdown/ButtonsDropdownIcon.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import EditButtonsDropdownWorkflows from '@/components/ButtonsDropdown/EditButtonsDropdownWorkflows.vue';
import { useButtonDropdown } from '@/store/modules/buttonDropdowns/getters';
import { projectHasPermission } from '@/store/modules/projects/getters';
import { ProjectPermissions } from '@ply-io/ply-front-shared-utilities';
export default {
	name: 'EditButtonsDropdown',
	props: {
		id: { type: Number },
	},
	components: {
		ButtonsDropdownIcon,
		EditButtonsDropdownWorkflows,
	},
	methods: {
		...mapActionsShorthand({ getButtonDropdown }),
		openEditButtonDropdownDesignDialog() {
			AppDialogManagerService.openEditButtonDropdownDesignDialog({ buttonDropdownId: this.id });
		},
	},
	computed: {
		...mapGettersShorthand({ useButtonDropdown, projectHasPermission }),
		buttonDropdown() {
			return this.useButtonDropdown(this.id);
		},
		hasEditPermissions() {
			return this.projectHasPermission(this.buttonDropdown.project, ProjectPermissions.ManageButtonDropdowns);
		},
	},
	async created() {
		this.isLoading = true;
		await this.getButtonDropdown({ id: this.id });
		this.isLoading = false;
	},
	data() {
		return {
			isLoading: false,
		};
	},
};
</script>

<style scoped lang="scss">
.content-wrapper {
	padding: 68px 0 0 0;
}
.inner-content-container {
	max-width: 780px;
}
.note-container {
	border-radius: 5px;
	padding: 14px 12px;
	background: #f9fafc;
	letter-spacing: 0px;
	color: #979797;
	font-size: 12px;
}
.design-button-container {
	border-radius: 8px;
	background: var(--white);
	border: 1px solid #dfe4f0;
	padding: 12px 28px 12px 12px;
}
.design {
	font-weight: bold;
	color: #4d4c51;
}
.edit-button-design-button {
	height: 21px !important;
	font-size: 13px !important;
	color: #262626 !important;
	border-radius: 5px !important;
	letter-spacing: 0px !important;
	font-weight: normal !important;
	background: #ffffff !important;
	border: 1px solid #dfe4ef !important;
}
</style>
